import { AfterViewInit, Component, Input, NgZone, OnInit, ViewChild } from '@angular/core';
import { panelList } from '../../models/momGenerateModel';
import { UntypedFormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MomService } from 'src/app/service/mom.service';
import { CkEditorConfig } from 'src/app/config/ckeditor-config';
import { ParticReviewSelectDialogComponent } from 'src/app/components/partic-review-select-dialog/partic-review-select-dialog.component';
import { PreviewMinutesDialogComponent } from 'src/app/components/preview-minutes-dialog/preview-minutes-dialog.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Globals } from 'src/app/service/global';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { NotifierService } from 'angular-notifier';
import { environment, environment_const, environment_label, environment_msg } from 'src/environments/environment';
import { UtilityService } from 'src/app/service/utility.service';
import { MeetingService } from 'src/app/service/meeting.service';
import { ConfirmDialogComponent } from 'src/app/components/confirm-dialog/confirm-dialog.component';
import { ProjectStatusDialogComponent } from 'src/app/components/right-side-opener/project-status-dialog.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatePipe } from '@angular/common';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MY_FORMATS } from 'src/app/components/grid-table/grid-table.component';

import { BreakpointState } from '@angular/cdk/layout';
import {
  BreakpointObserver,
  Breakpoints,
} from '@angular/cdk/layout';
import { Observable, Subscription } from 'rxjs';
import { NgIf } from '@angular/common';
import { SideNavServiceService } from 'src/app/service/side-nav-service.service';
import { FreeFormAgendaService } from 'src/app/service/free-form-agenda.service';
import { GrapesJsPopupComponent } from 'src/app/components/grapes-js-popup/grapes-js-popup.component';
import { FreeFormMinutesService } from 'src/app/service/free-form-minutes.service';
// import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import {
  DecoupledEditor,
  Bold,
  Essentials,
  Italic,
  Paragraph,
  Undo,
  Heading,
  Link,
  List,
  BlockQuote,
  Indent,
  IndentBlock,
  Table,
  TableToolbar,
  GeneralHtmlSupport,
  Underline,
  FontColor,
  FontBackgroundColor,
  Image as CKEImage,
  ImageUpload as CKEImageUpload,
  ImageToolbar as CKEImageToolbar,
  ImageCaption as CKEImageCaption,
  Mention
} from 'ckeditor5';

import { AgoraConfigService } from 'src/AgoraConfigService';
import { setupQuillUploadAdapter } from 'src/app/config/quill-common';
import { quillSharedToolbar } from 'src/app/config/quill-shared-toolbar';

// CKEditor 5 custom upload adapter for MoM image uploads
class MomUploadAdapter {
  private loader: any;
  private apiBaseUrl: string;
  private endpoints: any;
  private meetingId: number;
  private orgCode: string | null;
  private token: string | null;
  private userName: string | null;

  constructor(loader: any, agoraConfig: AgoraConfigService, meetingId: number) {
    this.loader = loader;
    this.apiBaseUrl = agoraConfig.getConfig().apiBaseUrl;
    this.endpoints = agoraConfig.getConfig().endpoints;
    this.meetingId = meetingId;
    this.orgCode = localStorage.getItem('orgCode');
    this.token = localStorage.getItem('token');
    this.userName = localStorage.getItem('encLoginName');
  }

  // Resize image client-side to maxWidth before upload. Returns resized File or original if smaller/failed.
  private resizeImageFile(file: File, maxWidth = 670): Promise<File> {
    return new Promise((resolve) => {
      try {
        // Do not resize GIFs to preserve animation
        if (file.type === 'image/gif') {
          resolve(file);
          return;
        }
        const url = URL.createObjectURL(file);
        const img = new Image();
        img.onload = () => {
          const { naturalWidth, naturalHeight } = img as HTMLImageElement;
          const scale = Math.min(1, maxWidth / naturalWidth);
          if (scale >= 1) {
            URL.revokeObjectURL(url);
            resolve(file);
            return;
          }
          const canvas = document.createElement('canvas');
          canvas.width = Math.round(naturalWidth * scale);
          canvas.height = Math.round(naturalHeight * scale);
          const ctx = canvas.getContext('2d');
          if (!ctx) {
            URL.revokeObjectURL(url);
            resolve(file);
            return;
          }
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
          const mime = (file.type === 'image/png' || file.type === 'image/jpeg') ? file.type : 'image/jpeg';
          canvas.toBlob((blob) => {
            URL.revokeObjectURL(url);
            if (!blob) {
              resolve(file);
              return;
            }
            const resized = new File([blob], file.name, { type: mime });
            resolve(resized);
          }, mime, 0.92);
        };
        img.onerror = () => {
          URL.revokeObjectURL(url);
          resolve(file);
        };
        img.src = url;
      } catch {
        resolve(file);
      }
    });
  }

  upload(): Promise<any> {
    return this.loader.file.then((file: File) => new Promise(async (resolve, reject) => {
      const xhr = new XMLHttpRequest();
      const url = `${this.apiBaseUrl}${this.endpoints.attachment}imageUpload`;
      xhr.open('POST', url, true);
      if (this.token) xhr.setRequestHeader('Authorization', `Bearer ${this.token}`);
      if (this.userName) xhr.setRequestHeader('userName', this.userName);

      xhr.responseType = 'json';

      const formData = new FormData();
      // Resize on client before sending if wider than max
      let fileToSend: File = file;
      try {
        fileToSend = await this.resizeImageFile(file, 670);
      } catch {}
      // Backend expects 'fileUpload' as field name (CKEditor 4 legacy contract)
      formData.append('fileUpload', fileToSend, fileToSend.name);
      // Attachment metadata similar to CKEditor 4 flow
      const attachmentJson = {
        fkEntityId: 0, // Not applicable for MoM editor; set 0 or a relevant entity if required
        fkMeetingId: this.meetingId,
        orgCode: this.orgCode
      } as any;
      formData.append('attachment', JSON.stringify(attachmentJson));

      xhr.addEventListener('error', () => reject('Image upload failed'));
      xhr.addEventListener('abort', () => reject());
      xhr.addEventListener('load', () => {
        const res = xhr.response;
        if (!res || xhr.status >= 400) {
          return reject(res && res.message ? res.message : 'Upload failed');
        }
        // Server returns { attachmentId, fileName, ... }
        const attachmentId = res.attachmentId;
        if (!attachmentId) {
          return reject('No attachmentId in response');
        }
        const downloadUrl = `${this.apiBaseUrl}${this.endpoints.attachment}imageDownload/${attachmentId}`;
        // CKEditor 5 expects an object with default URL
        resolve({ default: downloadUrl });
      });

      xhr.send(formData);
    }));
  }

  abort() {
    // No-op: XHR instance is scoped in upload(); cannot abort mid-flight easily without refactor.
  }
}
@Component({
  selector: 'app-minutes-of-meeting',
  templateUrl: './minutes-of-meeting.component.html',
  styleUrls: ['./minutes-of-meeting.component.css'],
  providers: [{ provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },

  { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
    , DatePipe]
})
export class MinutesOfMeetingComponent implements OnInit, AfterViewInit {
  panelListData = panelList
  meetingId!: number;
  meetingTitle!: String;
  meetingDate!: String;
  meetingTime!: String;
  duration!: String;
  tzName!: String;
  minutesReqJSON: any;
  minutesData: any;
  nodeValue: any;
  isApprovedTree:any=false;
  //@ViewChild('momCkEditor') public momCkEditor: any;
  nodeId: any;
  nodeType: any;
  nodeLevel: any;
  editorCurrentVal: any;
  clsName: string | undefined;
  spanText!: string;
  ckEditorConfig: any;
  children = [];
  pkMoMDetailId!: number;
  preamble!: string;
  curMomTitle!:String;
  isTaskChecked!: number;
  isNoteChecked!: number;
  isDecisionChecked!: number;
  //momTab!:momDetail[];
  curCursorElem!:HTMLElement;
  meetingResponse!:any;
  momList:any[]=[];
  isAllowMomCreation:boolean=true;
  curMomStatusCode:any;
  isAllMomApproved=true;
  selectParticiDialogRef!: MatDialogRef<ParticReviewSelectDialogComponent, any>;
  previewDialogRef!: MatDialogRef<PreviewMinutesDialogComponent, any>;
  meetingApproved = false;
  followUpCode:any="";
  previewTooltip = environment_label.label_preview;
  draftTooltip = environment_label.label_draft;
  approveTooltip = environment_label.label_approve;
  meetingIsConfidential: any;
  passworddecrypt: any;
  meetingInfoData: any;
  meetingDateInVT:any;
  meetingDisplayDate:any;
  meetingutctime: any;
  // Intendation for subAgendas
  tempArr: any[] = [];
  levelArr: any = [];
  insertHtml:any="";
  count = 0;
  agendaResponse: any;
  // Quill editor configuration/state
  public quillMomConfig: any = {
    enableTable : true,
    letter : false,
    modules: {
      toolbar: {
        container: [
          ['bold','italic','underline','strike'],
          [{ list: 'ordered' }, { list: 'bullet' }],
          [{ indent: '+1' }, { indent: '-1' }],
          [{ color: [] }, { background: [] }],
          [{ align: [] }],
          ['image','link']
        ],
        handlers: {}
      }
    },
    placeholder: ' ',
    theme: 'snow'
  };
  private quillInstances: Map<number, any> = new Map();
  private activeQuill?: any;
  constructor(private ngZone: NgZone,private readonly breakpointObserver: BreakpointObserver,public datepipe: DatePipe, private spinner: NgxSpinnerService,private dialog : MatDialog,private meetingService:MeetingService,private router: Router, private activatedroute: ActivatedRoute, private momService: MomService, private globals:Globals,private ckeditorConfigObj: CkEditorConfig,private notifier: NotifierService,private utilService:UtilityService,private sideNav : SideNavServiceService,private commonService: FreeFormAgendaService, private freeFormMinutesService:FreeFormMinutesService, private agoraConfig: AgoraConfigService) {
    // CKEditor 5 (Classic) configuration
    this.ckEditorConfig = {
        plugins: [
              Bold,
              Essentials,
              Italic,
              Paragraph,
              Undo,
              Heading,
              Link,
              List,
              BlockQuote,
              Indent,
              IndentBlock,
              Table,
              TableToolbar,
              GeneralHtmlSupport,
              Underline,
              FontColor,
              FontBackgroundColor,
              CKEImage,
              CKEImageUpload,
              CKEImageToolbar,
              CKEImageCaption,
              Mention
            ],
      toolbar: [
        'undo','redo','|','bold','italic','underline','|','numberedList','bulletedList','|','insertTable','|','fontColor','fontBackgroundColor','|','imageUpload'
      ],
      table: {
        contentToolbar: [ 'tableColumn', 'tableRow', 'mergeTableCells' ]
      },
    htmlSupport: {
        allow: [
          {
            name: /^.*$/,
            classes: true,
            attributes: true,
            styles: true
          }
        ],        
        disallow: []
      },
      htmlEmbed: {
        showPreviews: true
      }
    };
  }

  //tabTitleContent = new FormControl()
  disabled = false;
  compact = true;
  invertX = false;
  invertY = false;
  isExtraSmall: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.XSmall
  );
  isMedium: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.Medium
  )
  isSmall: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.Small
  )
  shown: 'native' | 'hover' | 'always' = 'native';
  ngOnInit(): void {
    this.activatedroute.queryParams.subscribe(
      params => {
        if (params.meetingResult != null && params.meetingResult != undefined) {

          
          var meetingInfo = JSON.parse(params.meetingResult);
          this.meetingResponse=meetingInfo;
          
          this.meetingIsConfidential = meetingInfo.isConfidential
          this.meetingId = meetingInfo.meetingId;
          this.meetingTitle = meetingInfo.meetingTitle;
          this.meetingDate = meetingInfo.meetingDateFullFormat;
          // this.meetingTime = meetingInfo.meetingStartTime;
          this.duration = meetingInfo.duration;
          //this.tzName = meetingInfo.tzName;
          this.tzName = this.globals.vShortTimeZone;
          this.meetingApproved = params.approved;
          this.meetingutctime=meetingInfo.meetingUTCDate
          const curSysDate = new Date(this.meetingutctime);
          const meetUtc = curSysDate.getTime() + (curSysDate.getTimezoneOffset() * 60000);//current utc date with time
          const fullDate = new Date(meetUtc + (3600000 * (this.globals.vTimeZoneIntOffset)));//convert utc to corresponding timezone
          const hour = this.addZero(fullDate.getHours());
          const minutes = this.addZero(fullDate.getMinutes());
          this.meetingTime = hour + ":" + minutes;
          this.meetingDateInVT=new Date(fullDate);
          this.meetingDisplayDate = this.datepipe.transform(this.meetingDateInVT,'fullDate');

          if(this.meetingResponse!=null && this.meetingResponse.followUpCode!=undefined && this.meetingResponse.followUpCode!=null && this.meetingResponse.followUpCode==environment_const.followupTypeCode){
            this.followUpCode= this.meetingResponse.followUpCode;
          }
        }
      });
    this.fetchMoMDetailListByMeeting('Y').then(()=>{
      this.initializeCkeditor();
    });
    this.checkMomcreation().then(()=>{});

  }
  addZero(i: any) {
    if (i < 10) {
      i = "0" + i;
    }
    return i;
  }
  checkMomcreation(){
    this.isAllowMomCreation=true;
    return new Promise(async (resolve, reject) => {
      var req={
        "fkMeetingEntityId":this.meetingId,
        "orgCode":this.globals.orgCode,
        "userId":this.globals.userId
      }
      await this.momService.computeMomGeneration(req).subscribe(res => {
        if (res.body != null && res.body != undefined && this.utilService.nvl(res.body.isAllowMomCreation)!="Y") {
          this.isAllowMomCreation=false;
        }
      });
      resolve(this.isAllowMomCreation);
    });
  }

  fetchMoMDetail() {
    return new Promise(async (resolve, reject) => {
      await this.momService.fetchMoMDetail(this.meetingId).subscribe(res => {
        if (res.body != null && res.body != undefined) {
          this.pkMoMDetailId = res.body['pkMomDetailId'];
          this.preamble = res.body['genericName'];
          if(res.body['momContent']!=null && res.body['momContent']!=undefined){
            this.nodeValue=res.body['momContent'];
          }
          resolve(this.pkMoMDetailId);
        }
      });
    });
  }

  fetchMoMDetailListByMeeting(initFlag:any){
    return new Promise(async (resolve, reject) => {
      await this.momService.fetchMoMDetailListByMeeting(this.meetingId).subscribe(res => {
        if (res.body != null && res.body != undefined) {
          //this.momList=res.body;
          this.momList=res.body;
          if(this!.momList!=null && this!.momList!=undefined && this!.momList.length>0 && initFlag!=undefined && initFlag!=null && initFlag=="Y"){
            if(this!.momList[0].pkMomDetailId!=undefined){
              this.pkMoMDetailId=this!.momList[0]!.pkMomDetailId;
              this.preamble = this!.momList[0].genericName;
              this.curMomStatusCode = this.momList[0].momStatusCode;
              this.curMomTitle=this.momList[0].momTitle;
              if(this!.momList[0].momContent!=null && this!.momList[0].momContent!=undefined){
                this.nodeValue=this!.momList[0].momContent;
              }else{
                this.nodeValue="";
              }
            }
          }
          resolve(this.momList);
        }
      });
    });
  }

  redirectToMeeting(meetingId: number,isConf :any) {
 
    if(isConf == 'Y'){
      this.passworddecrypt = localStorage.getItem("savedpasswords" + "_"+ this.meetingId);
      
      this.router.navigate(['schedule'], { queryParams: { "meetingResult": JSON.stringify({ "meetingId": this.meetingId, "decryptKey": this.passworddecrypt, "isConfidential": "Y","showMoM": true, meetingObj: this.meetingResponse }) }, skipLocationChange: true, replaceUrl: false, });

      // var jsonObj: any = {};
      // jsonObj = {
      //   "meetingId": this.meetingId,
      //   "userId": this.globals.userId,
      //   "deletedFlag": 0,
      //   "rowStatus": "",
      //   "decryptKey": this.passworddecrypt,
      //   "visitorTimeZone": this.globals.vTimeZone,
      //   "meetingStartTime": this.meetingTime,
      // }
      // this.meetingService.fetchMeetingConfInfo(jsonObj).subscribe(
      //   (meetingRes: any) => {
      //     this.meetingInfoData = meetingRes.body
      
      //     if(this.meetingTitle == meetingRes.body.encryptTitleKey){
      //       this.spinner.show();
      //     const d = this.dialog.open(ProjectStatusDialogComponent, {
      //       data: { meetingData: this.meetingInfoData, hide: false, hideUseTemplate: true },
      //       panelClass: ['animate__animated', 'animate__slideInRight', 'responsive-class'],
      //       disableClose: false,

      //     })

      //     d.afterClosed().subscribe(() => {

      //     });
      //     this.spinner.hide();
      //   } 
      //   },
      //  );


    }else{
      this.router.navigate(['schedule'], { queryParams: { "meetingResult": JSON.stringify({ "meetingId": meetingId, "showMoM": true}) }, skipLocationChange: true, replaceUrl: false });
    }
  }

  selected = new UntypedFormControl(0);
  // selectedPkMom = new FormControl();
  addTab(selectAfterAdding: boolean,index:any) {
    //this.tabs.push('New');
    this.saveEditorContent();
    
    this.saveOrUpdateMomDetail('Y').then((resp:any)=>{
      //if (selectAfterAdding) {
      this.pkMoMDetailId =resp.pkMomDetailId;
      this.curMomStatusCode=resp.momStatusCode;
      this.curMomTitle=resp.momTitle;
      //this.momList.splice(this.selected.value+1,0,resp);
      //this.selected.setValue(this.selected.value+1);
      this.momList.push(resp);
      if(this.momList.length==1){
        this.selected.setValue(0);
      }else{
        this.selected.setValue(this.momList.length);
      }

      this.nodeValue="";
      //this.initializeCkeditor();
      //}
    })

  }
  public onSelectedTabChange(tabEvent: MatTabChangeEvent)  {
    
    this.initializeCkeditor();
  }
  loadtab(){
    
  }
  
  initializeEditor() {
    // No-op: CKEditor 5 Angular component handles creation.
  }
 
destroyCKEditorInstances() {
  // No-op with Angular wrapper.
}
  initializeCkeditor(){
    this.initializeEditor();
    // Angular CKEditor component will manage the instance lifecycle.
    this.isApprovedTree = (this.curMomStatusCode!=undefined && this.curMomStatusCode==environment_const.momApproveStatus);
  }

  onQuillReady(quill: any, tab: any) {
    // Store Quill instance for later programmatic access
    this.quillInstances.set(tab.pkMomDetailId, quill);
    this.activeQuill = quill;
    // Register shared toolbar and upload adapter
    // try { quillSharedToolbar.registerEditor(quill, 'quill-shared-toolbar'); } catch {}
    try {
      const cfg = this.agoraConfig.getConfig();
      setupQuillUploadAdapter(quill, cfg.apiBaseUrl, cfg.endpoints.attachment, this.meetingId, 0);
    } catch {}
    // Ensure editor reflects current nodeValue
    try { if (typeof this.nodeValue === 'string') { this.setQuillHtml(quill, this.nodeValue); } } catch {}
    // Keep nodeValue in sync as user types (but don't save yet)
    try {
      quill.on('text-change', () => {
        try { this.nodeValue = quill.root.innerHTML; } catch {}
      });
    } catch {}
  }

  private setQuillHtml(quill: any, html: string) {
    try {
      quill.setContents([]);
      (quill as any).clipboard.dangerouslyPasteHTML(0, html || '', 'silent');
      const len = quill.getLength();
      quill.setSelection(Math.max(0, len - 1), 0, 'silent');
      // Update nodeValue after setting HTML so that isEmptyMomContent can detect content
      this.nodeValue = quill.root.innerHTML || html;
    } catch {}
  }

  onEditorBlur(event: any) {
    // Call saveEditorContent only when editor loses focus (blur event)
    try {
      this.saveEditorContent();
    } catch (error) {
      console.error('Error saving on blur:', error);
    }
  }

  enableMouseHandler(){
    var tempThis=this;
    setTimeout(function(){
      // var mouseMoveHandler = function(event:any) {
      //   
      //   tempThis.curCursorElem=event.target;
      //   
      //   }
      var iframeElem:any = $("#momCkEditor"+tempThis.pkMoMDetailId).parent().find("iframe").contents().find("body")[0];
      
      if(iframeElem!=undefined){
        //iframeElem!.removeEventListener('click',mouseMoveHandler,false);
        // iframeElem!.addEventListener('click', mouseMoveHandler);
        $("#momCkEditor"+tempThis.pkMoMDetailId).parent().find("iframe").contents().find("body").on("click", function(eve:any){
          
          tempThis.curCursorElem=eve.target;
        });
      }
    },50);
  }
  setckData(tabInfo:any){
    if(tabInfo.momContent!=null && tabInfo.momContent!=undefined && tabInfo.momContent!="null" && tabInfo.momContent!="undefined"){
      return tabInfo.momContent;
    }else{
      return "";
    }
  }
  curCkeditorIns(event:any){
    
  }
  checkAllMomApproved(){
    this.isAllMomApproved=true;
    if(this.momList!=undefined && this.momList!=null && this.momList.length>0){
      this.momList.forEach((element:any) => {
        if(element!=null && element.momStatusCode!=null && element.momStatusCode!=undefined && (element.momStatusCode!=environment_const.momApproveStatus)){
          this.isAllMomApproved=false;
          return;
        }
      });
    }else{
      this.isAllMomApproved=false;
    }
  }

  editTabTitle(e : any, id : any, signal : any,index:any){
    let tabTitle = <HTMLElement>document.getElementById("momTabTitle"+id)
    if(signal){
      tabTitle.contentEditable = "true"
      setTimeout(() => {
        tabTitle.focus();
        this.utilService.placeCaretAtEnd(tabTitle);
      },100)
    }
    else{
      
      if(e.target.outerText!=null && e.target.outerText!=undefined && e.target.outerText!=""){
        this.curMomTitle=e.target.outerText;
        this.saveOrUpdateMomDetail('N').then((resp:any)=>{
          tabTitle.contentEditable = "false";
          this.momList[index].momTitle=this.curMomTitle;
          //this.tabTitleContent.setValue(e.target.outerText);
        });
        

      }else{
        
        tabTitle.focus();
        this.utilService.placeCaretAtEnd(tabTitle);
        e.stopPropagation();
        e.preventDefault();
        return false;
      }
    }
    return true;
  }

  deleteTab(e : any, id : any, signal : any){
    window.alert("delete triggered")
  }

  suppressKeyEvent(event : any){
    if(event.keyCode == '13'){
      event.preventDefault()
      return false
    }
    
    event.stopPropagation();
    return true;
  }

  confirmDeleteMomDetail(pkMoMDetailId:any,index:any){
    this.dialog.open(ConfirmDialogComponent, {
      data: {
        dialogTitle : "Confirmation",
        dialogContent : environment_msg.msg_confirm_delete_mom
      },
    }).afterClosed().subscribe(response => {
      if(response == true){
        this.deleteMomDetail(pkMoMDetailId,index);
              }
    });
  }
  deleteMomDetail(pkMoMDetailId: any, index: any) {
    return new Promise(async (resolve, reject) => {
      await this.momService.deleteMomDetail(pkMoMDetailId).subscribe(res => {
        if (res.body != null && res.body != undefined && res.body.deletedFlag == 1) {
          this.momList.splice(index, 1);
          if(this.momList.length!=0){
          if (index != 0 && index == this.momList.length) {
            this.pkMoMDetailId = this.momList[index - 1].pkMomDetailId
          }
          else {
            this.pkMoMDetailId = this.momList[index].pkMomDetailId

          }
        }
          this.notifier.show({
            type: 'success',
            message: environment_msg.msg_success_delete_mom
          });
          resolve(res.body);
        }
      });
    });
  }
  //editTabMom
  editTabMom(id : any){
    document.getElementById(id+'+tabTitle')?.setAttribute('contentEditable','true')
    setTimeout(() => {
      document.getElementById(id+'+tabTitle')?.focus()
    },1000)
  }

  //removeContentEditable
  removeContentEditable(id : any){
    document.getElementById(id+'+tabTitle')?.setAttribute('contentEditable','false')
  }

  saveOrUpdateMomDetail(isNewTab:any) {
    var json:any={
      "fkMeetingEntityId":this.meetingId,
      "userId":this.globals.userId,
      "orgCode":this.globals.orgCode,
      "visitorTimeZone":this.globals.vTimeZone
    };
    if(isNewTab!=null && isNewTab!=undefined && isNewTab!="Y"){
      json["pkMomDetailId"] =this.pkMoMDetailId;
      json["momTitle"]=this.curMomTitle;
      json["momStatusCode"]=this.curMomStatusCode
    }
    return new Promise(async (resolve, reject) => {
      await this.momService.saveOrUpdateMomDetail(json).subscribe(res => {
        if (res.body != null && res.body != undefined) {
          //this.momList.push(res.body);
          resolve(res.body);
        }
      });
    });
  }
  isAppendFollowUpDate(node:any){
    if(this.followUpCode==environment_const.followupTypeCode && this.meetingId!=undefined && this.meetingId!=node.meetingId){
      return true;
    }else{
      return false;
    }
  }
  ckeditorContent(node: any) {
    var nodeType = node.type;
    var insertHtml ="";
    var isAppendFollowUpDate:boolean=this.isAppendFollowUpDate(node);
    
    // Build HTML content based on node type
    if(nodeType=="AI" || nodeType=="MN" || nodeType=="MD"){
      this.levelArr=[];
      insertHtml = this.buildMinutes(node,isAppendFollowUpDate);
    }else if(nodeType=="AG"){
      this.insertHtml="";
      this.levelArr=[];
      this.count=0;
      insertHtml= this.buildAgenda(node,isAppendFollowUpDate);
    }else if(nodeType="MT"){
      this.insertHtml="";
      insertHtml = this.buildMeeting(node,isAppendFollowUpDate);
    }
    
    // Get Quill instance for current tab
    const quill = this.quillInstances.get(this.pkMoMDetailId);
    if (!quill) {
      console.error('Quill instance not found for tab:', this.pkMoMDetailId);
      return;
    }
    try {
      const curHtml = quill.root.innerHTML || '';
      const nextHtml = (!curHtml || /^\s*(<p><br><\/p>|<p><\/p>)?\s*$/.test(curHtml)) ? insertHtml : curHtml + insertHtml;
      this.setQuillHtml(quill, nextHtml);
      try { quill.focus(); } catch {}
    } catch (e) {
      console.error('Failed to insert content into Quill:', e);
    }
    
    this.saveEditorContent();
    document.querySelectorAll('imageAlign').forEach((data, index) => {
      data.setAttribute('style','width : 500px')
    })
  }

  ckeditorContent_new(node: any) {
    var nodeType = node.type;
    var isAppendFollowUpDate:boolean=this.isAppendFollowUpDate(node);
    
    // Build content asynchronously based on node type
    if(nodeType=="AI" || nodeType=="MN" || nodeType=="MD"){
      this.buildMinutes_new(node,isAppendFollowUpDate).then((html:any)=>{
        this.appendBuild(html);
      });
    }else if(nodeType=="AG"){
      this.buildAgenda_new(node,isAppendFollowUpDate).then((html:any)=>{
        this.appendBuild(html);
      });
    }else if(nodeType="MT"){
      this.buildMeeting_new(node,isAppendFollowUpDate).then((html:any)=>{
        this.appendBuild(html);
      });
    }
  }

  appendBuild(insertHtml:any){
    // Get Quill instance for current tab
    const quill = this.quillInstances.get(this.pkMoMDetailId);
    if (!quill) {
      console.error('Quill instance not found for tab:', this.pkMoMDetailId);
      return;
    }
    try {
      const curHtml = quill.root.innerHTML || '';
      const nextHtml = (!curHtml || /^\s*(<p><br><\/p>|<p><\/p>)?\s*$/.test(curHtml)) ? insertHtml : curHtml + insertHtml;
      this.setQuillHtml(quill, nextHtml);
      try { quill.focus(); } catch {}
    } catch (e) {
      console.error('Failed to insert content into Quill:', e);
    }
    this.saveEditorContent();
  }

  findMyCurSor(){
    var iframeElem = $("#momCkEditor"+this.pkMoMDetailId).parent().find("iframe").contents().find("body");
    if(this.curCursorElem!=null && this.curCursorElem!=undefined && !this.curCursorElem.classList.contains("cke_editable")){
      var curCursorId = this.curCursorElem.getAttribute("id");
    }
  }

  fetchActualMinutes(node:any){
    return new Promise(async(resolve, reject) => {
      if(node.type!=null){
        if(node.type==environment.noteEntityType){
          await this.meetingService.fetchNotes(node.id).subscribe((data: any) => {
            
            if(data!=null && data.body!=null && data.body.noteDescription!=null){
              node.text=data.body.noteDescription;
            }
            resolve(node);
          });
        }else if(node.type==environment.decisionEntityType){
          await this.meetingService.fetchDecision(node.id).subscribe((data: any) => {
            if(data!=null && data.body!=null && data.body.noteDescription!=null){
              node.text=data.body.noteDescription;
            }
            resolve(node);
          });
        }else if(node.type==environment.taskEntityType){
          await this.meetingService.fetchTaskInfo(node.id).subscribe((data: any) => {
            if(data!=null && data.body!=null && data.body.taskTitle!=null){
              node.text=data.body.taskTitle;
            }
            resolve(node);
          });
        }
      }else{
        resolve(node);
      }
    });
  }

  async buildMinutes_new(node:any,isAppendFollowUpDate:boolean){
    var insertHtml = "";
    return await new Promise(async(resolve, reject) => {
      await this.fetchActualMinutes(node).then((data:any)=>{
        node=data;
        console.log("node : ",node);
        if(node!=null && node!=undefined){
          var nodeType = node.type;
          if(nodeType=="MN" || nodeType=="MD"){
            insertHtml = ("<div id='"+ node.id +"' class='minCls agnote" + node.id + "' nodeType='"+nodeType+"' agendaId='"+node.agendaId+"' meetingId='"+node.meetingId+"'>" + node.text);
          }else if(nodeType=="AI"){
            insertHtml = ("<div id='"+ node.id +"' class='minCls agnote" + node.id + "' nodeType='"+nodeType+"' agendaId='"+node.agendaId+"' meetingId='"+node.meetingId+"'>" + node.text );
            if((node.actionItemOwner!=null && node.actionItemOwner!=undefined && node.actionItemOwner!="[]" && node.actionItemOwner.length>0) || (this.utilService.nvl(node.guestOwnerName)!="")){
              insertHtml+='<span class="assignCls" contenteditable="false"><b> Owner(s): </b></span>';
            }
            if(node.actionItemOwner!=null && node.actionItemOwner!=undefined && node.actionItemOwner!="[]"){
              node.actionItemOwner.forEach((actionItemOwnerList: any, index: any) => {
                insertHtml+='<span class="atwho-inserted" data-atwho-at-query="@" id="'+actionItemOwnerList.fkSecUserOwner+'" fkuserid="'+actionItemOwnerList.fkSecUserOwner+'" contenteditable="false">'+actionItemOwnerList.ownerName;
                if((node.actionItemOwner?.length>1) && (index!=node.actionItemOwner?.length-1)){
                  insertHtml+=",";
                }
                insertHtml+="</span>&nbsp;";
              });
            }
            if(this.utilService.nvl(node.guestOwnerName)!=""){
              
              String(node.guestOwnerName).split(",").forEach((guestName:any) => {
                // 
                // insertHtml+='<span class="atwho-inserted" data-atwho-at-query="@" id="" contenteditable="false">'+guestName+'</span>&nbsp;,';
              });
            }
            if(this.utilService.nvl(node.dueDateStr)!=""){
              insertHtml+='<span contenteditable="false" class="minDateCls"><span class="dueLabelCls"><b>Due Date:&nbsp;</b></span>'+node.dueDateStr;
              if (this.globals.showTimezone_Date != null && this.globals.showTimezone_Date=="Y") {
                insertHtml+='&nbsp;<span class="taskTimezoneCls">'+this.globals.vShortTimeZone+'</span>';
              }
              insertHtml+='</span>&nbsp;';
            }
          }
          if(isAppendFollowUpDate){
            insertHtml+='- '+node.meetingDate;
          }
          insertHtml+="</div>";
        }
      });
      resolve(insertHtml);
      //return insertHtml;
    });
  }
  trimHtmltoText(node:any){
    var text="";
    if(node.actualText!=undefined){
      var tempTxt = $("<p>").append(node.actualText);
      text=$($(tempTxt).html()).text().trim();
    }
    return text;
  }
  public buildMinutes(node:any,isAppendFollowUpDate:boolean){
    let indent="";
      if(node.level>0 && node.level !=undefined ) {
        this.levelArr.push({id: node.agendaId, level: node.level});
      }
      for(let i of this.levelArr) {
        if(i.id == node.agendaId) {
     
          indent = (i.level ) * 10 + "px";
        }
      }
    var insertHtml = "";
    if(node!=null && node!=undefined){
      var nodeType = node.type;
      if(nodeType=="MN" || nodeType=="MD"){
        insertHtml = ("<div style='margin-left:"+indent+"' id='"+ node.id +"' class='minCls agnote" + node.id + "' nodeType='"+nodeType+"' agendaId='"+node.agendaId+"' meetingId='"+node.meetingId+"'>" + node.actualText);
      }else if(nodeType=="AI"){
        insertHtml = ("<div style='margin-left:"+indent+"' id='"+ node.id +"' class='minCls agnote" + node.id + "' nodeType='"+nodeType+"' agendaId='"+node.agendaId+"' meetingId='"+node.meetingId+"'>" + node.actualText );
        if((node.actionItemOwner!=null && node.actionItemOwner!=undefined && node.actionItemOwner!="[]" && node.actionItemOwner.length>0) || (this.utilService.nvl(node.guestOwnerName)!="")){
          insertHtml+='<span class="assignCls" contenteditable="false"><b> Owner(s): </b></span>';
        }
        if(node.actionItemOwner!=null && node.actionItemOwner!=undefined && node.actionItemOwner!="[]"){
          node.actionItemOwner.forEach((actionItemOwnerList: any, index: any) => {
            insertHtml+='<span class="atwho-inserted" data-atwho-at-query="@" id="'+actionItemOwnerList.fkSecUserOwner+'" fkuserid="'+actionItemOwnerList.fkSecUserOwner+'" contenteditable="false">'+actionItemOwnerList.ownerName;
            if((node.actionItemOwner?.length>1) && (index!=node.actionItemOwner?.length-1)){
              insertHtml+=",";
            }
            insertHtml+="</span>&nbsp;";
          });
        }
        if(this.utilService.nvl(node.guestOwnerName)!=""){
          
          String(node.guestOwnerName).split(",").forEach((guestName:any) => {
            // 
            // insertHtml+='<span class="atwho-inserted" data-atwho-at-query="@" id="" contenteditable="false">'+guestName+'</span>&nbsp;,';
          });
        }
        if(this.utilService.nvl(node.dueDateStr)!=""){
          insertHtml+='<span contenteditable="false" class="minDateCls">'+node.dueDateStr;
          if (this.globals.showTimezone_Date != null && this.globals.showTimezone_Date=="Y") {
            insertHtml+='&nbsp;<span class="taskTimezoneCls">'+this.globals.vShortTimeZone+'</span>';
          }
          insertHtml+='</span>&nbsp;';
        }
      }
      if(isAppendFollowUpDate){
        insertHtml+='- '+node.meetingDate;
      }
      insertHtml+="</div>";
    }
    return insertHtml;
  }

  public copyMomInfo(momInfo:any){
    this.momService.copyMomDetail(momInfo).subscribe((resp:any)=>{
      var respBody= resp.body;
      // this.momList.splice(this.selected.value+1,0,respBody);
      // this.selected.setValue(this.selected.value+1);
      this.momList.push(respBody);
      this.selected.setValue(this.momList.length);
      this.pkMoMDetailId =respBody.pkMomDetailId;
      this.curMomStatusCode=respBody.momStatusCode;
      this.curMomTitle=respBody.momTitle
      this.nodeValue=respBody.momContent;
    });
  }
   
  public buildAgenda(node:any,isAppendFollowUpDate:boolean){
    console.log("buildAgenda node: ",node);
    var indent="";
    if(node.level!=0 && this.count != 0){
      if(node.level==1){
        indent = node.level * 0 + "px";
      }else{
        indent = node.level * 5 + "px";
      }
    }
    this.count++;
     this.insertHtml+= "<span style='margin-left: " + indent + ";' id='agTitleDiv" + node.agendaId + "' class='agendaTitle" + node.agendaId + " agCls' agendaId='" + node.agendaId + "' meetingId='" + node.meetingId + "'><b>" + node.agendaTitle + "</b>";

    if(isAppendFollowUpDate){
      this.insertHtml+='<b> - '+node.meetingDate+'</b>';
    }
    this.insertHtml+="</span>";
    if(!!node.children && node.children.length > 0){
      node.children.forEach((subNode: any) => {
        this.insertHtml+=this.buildMinutes(subNode,false);
        if(subNode.type=="AG"){
          this.buildAgenda(subNode,isAppendFollowUpDate)
        }
      });
    }
    console.log("final load content : ",this.insertHtml)
    return this.insertHtml;
  }

  public buildMeeting(node:any,isAppendFollowUpDate:boolean){
    var insertHtml = "";//"<div id='meetingTitleDiv" + node.meetingId + "' class='meetingtitle" + node.meetingId + " meetTitle' meetingId=" + node.meetingId + ">" + node.meetingTitle + "</div>";
    if(!!node.children && node.children.length > 0){
      node.children.forEach((subNode: any) => {
        this.insertHtml="";
        insertHtml+=this.buildAgenda(subNode,isAppendFollowUpDate);
      });
    }
    return insertHtml;
  }

  public constructAgenda_new(node:any,isAppendFollowUpDate:boolean){
    return new Promise(async(resolve, reject) => {
      var insertHtml= "<div id='agTitleDiv"+node.agendaId+"' class='agendaTitle" + node.agendaId + " agCls' agendaId='" + node.agendaId + "' meetingId='"+node.meetingId+"'><b>" + node.agendaTitle + "</b>";
      if(isAppendFollowUpDate){
        insertHtml+='<b> - '+node.meetingDate+'</b>';
      }
      insertHtml+="</div>";
      resolve(insertHtml);
    });
  }

  async buildAgenda_new(node:any,isAppendFollowUpDate:boolean){
    return  new Promise(async(resolve, reject) => {
      var insertHtml="";
      // var insertHtml= "<div id='agTitleDiv"+node.agendaId+"' class='agendaTitle" + node.agendaId + " agCls' agendaId='" + node.agendaId + "' meetingId='"+node.meetingId+"'><b>" + node.agendaTitle + "</b>";
      // if(isAppendFollowUpDate){
      //   insertHtml+='<b> - '+node.meetingDate+'</b>';
      // }
      // insertHtml+="</div>";
      await this.constructAgenda_new(node,isAppendFollowUpDate).then(async(agHtml:any)=>{
        insertHtml=agHtml;
        if(!!node.children && node.children.length > 0){
          await node.children.forEach(async(subNode: any) => {
            await this.buildMinutes_new(subNode,false).then((html:any)=>{
              insertHtml+=html;
            });
          });
          resolve(insertHtml);
        }else{
          resolve(insertHtml);
        }
        //return insertHtml;

      });
    });
  }

  public buildMeeting_new(node:any,isAppendFollowUpDate:boolean){
    return new Promise(async(resolve, reject) => {
      var insertHtml = "";//"<div id='meetingTitleDiv" + node.meetingId + "' class='meetingtitle" + node.meetingId + " meetTitle' meetingId=" + node.meetingId + ">" + node.meetingTitle + "</div>";
      if(!!node.children && node.children.length > 0){
        await node.children.forEach((subNode: any) => {
          this.buildAgenda_new(subNode,isAppendFollowUpDate).then((html:any)=>{
            insertHtml+=html;
          });
        });
        resolve(insertHtml);
      }else{
        resolve(insertHtml);
      }

      //return insertHtml;

    });
  }

  taskMinutePush(isChecked: any) {
    this.isTaskChecked = isChecked;
  }
  noteMinutePush(isChecked: any) {
    this.isNoteChecked = isChecked;
  }
  decisionMinutePush(isChecked: any) {
    this.isDecisionChecked = isChecked;
  }

  ngAfterViewInit(): void {
  }

  ngDoCheck(){
    
  }
  viewTabContent(curTabInfo:any,index:any){
    this.saveEditorContent();//save previous content before moving to another tab
    this.pkMoMDetailId=curTabInfo.pkMomDetailId;
    this.nodeValue=curTabInfo.momContent;
    this.preamble=curTabInfo.genericName;
    this.curMomStatusCode=curTabInfo.momStatusCode;
    this.curMomTitle=curTabInfo.momTitle;
    if(this.curMomStatusCode==environment_const.momApproveStatus){
      this.isApprovedTree=true;
    }else{
      this.isApprovedTree=false;
    }
    // Readonly handled by [disabled] binding on <ckeditor>
  }

  onChange(event: any): void {
    this.saveEditorContent();
  }
  savePreamble(event: any): void {
    if (this.preamble != null && this.preamble != undefined) {
      this.minutesReqJSON = { "meetingId": this.meetingId, "pkMomDetailId": this.pkMoMDetailId, "genericName": this.preamble };
      this.momService.savePreambleNote(this.minutesReqJSON).subscribe(res => {
        this.momList[this.selected.value].genericName=this.preamble;
      });
    }
  }
  saveEditorContent(){
    return new Promise(async (resolve, reject) => {
      const textareaContent = this.nodeValue || '';
      //if(textareaContent!=null && $.trim(textareaContent)!="" && $.trim(textareaContentTxt)!="" && textareaContent!="null" && textareaContent!=undefined && textareaContent!="undefined" && textareaContent!="<br>"){
      var minutesReqJSON = { "fkMeetingEntityId": this.meetingId, "pkMomDetailId": this.pkMoMDetailId, "followUpCode": "", "momContent": textareaContent, "editMomFlag": "N" };
      
      if (this.curMomStatusCode != undefined && this.curMomStatusCode != null && this.curMomStatusCode != environment_const.momApproveStatus) {
        this.momService.saveMinutesAsBlob(minutesReqJSON).subscribe(() => {
          // if(isSetValue){
          if (this.momList[this.selected.value] != undefined) {
            this.momList[this.selected.value].momContent = textareaContent;
            resolve(textareaContent);
          }
          // }
        });
      }
    }).catch(error => {
      this.sideNav.alertNotifyError('Unable to save content');
    });
  }
  isEmptyMomContent(){
    const html = this.nodeValue || '';
    
    // If HTML is empty string, it's empty
    if (!html || html.trim() === '') {
      return true;
    }
    
    // Check for images
    if(html.includes('img') || html.includes('imageAlign')){
      return false;
    }
    
    // Remove Quill's default empty structures (empty paragraph, breaks)
    let cleanHtml = html
      .replace(/<p><br><\/p>/g, '')  // Empty paragraph with break
      .replace(/<p><\/p>/g, '')       // Empty paragraph
      .replace(/<br>/g, '')           // Standalone breaks
      .replace(/^\s*<p>\s*<\/p>\s*$/g, ''); // Paragraph-only content
    
    // Extract text content
    const text = $('<div>').html(cleanHtml).text().trim();
    
    // If no text after cleaning, it's empty
    if (text.length === 0) {
      return true;
    }
    
    // Check if HTML has any meaningful content (not just formatting tags)
    // Remove common formatting tags and see if anything remains
    const withoutFormatting = cleanHtml
      .replace(/<\/?[bi]{1,2}>/gi, '')           // bold, italic, underline
      .replace(/<\/?u>/gi, '')                   // underline
      .replace(/<\/?strike>/gi, '')              // strikethrough
      .replace(/<\/?strong>/gi, '')              // strong
      .replace(/<\/?em>/gi, '')                  // emphasis
      .replace(/<\/?span[^>]*>/g, '')           // spans
      .replace(/<\/?div[^>]*>/g, '')            // divs
      .replace(/<\/?p[^>]*>/g, '')              // paragraphs
      .replace(/<\/?blockquote[^>]*>/g, '')     // blockquotes
      .replace(/<\/?li[^>]*>/g, '')             // list items
      .replace(/<\/?ul[^>]*>/g, '')             // unordered lists
      .replace(/<\/?ol[^>]*>/g, '')             // ordered lists
      .trim();
    
    return withoutFormatting.length === 0;
  }
  openPreviewSelectedParticipantsDialog(){
    var tempThis=this;
    this.checkAllMomApproved();
    if(this.momList==null || this.momList==undefined || this.momList.length<=0){
      this.notifier.show({
        type: 'error',
        message: environment_msg.msg_error_create_mom
      });
    }else if(this.isAllMomApproved){
      this.notifier.show({
        type: 'error',
        message: environment_msg.msg_error_mom_already_approved
      });
    }else if(this.isEmptyMomContent()){
      this.notifier.show({
        type: 'error',
        message: environment_msg.msg_error_mom_content
      });
    }else{
      this.spinner.show();
      this.saveEditorContent().then((req: any) => {
        this.spinner.hide();
        this.selectParticiDialogRef = this.dialog.open(ParticReviewSelectDialogComponent, {
          data: {
            title: "Participants Review Selection", curPkMoMDetailId: this.pkMoMDetailId, momList: this.momList,
            meetingResp: this.meetingResponse
          },
          panelClass: ['animate__animated', 'animate__slideInLeft'],
          disableClose: true,
          position : {
            left : "0%"
          },
          maxWidth : "100%",
          maxHeight: "100vh",
          width: "50%",
          height : "100vh"
        });
        const mediumDialogSubscription = this.isMedium.subscribe(size => {
          if(size.matches){
            this.selectParticiDialogRef.updateSize('70vw','100vh');
          }
        })
        const smallSubscription = this.isSmall.subscribe(size => {
          if(size.matches){
            this.selectParticiDialogRef.updateSize('100vw', '100vh');
          }
        })
        const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
          if (size.matches) {
            this.selectParticiDialogRef.updateSize('100vw', '100vh');
          }
        });
        this.selectParticiDialogRef.afterOpened().subscribe(()=>{
          this.removeCkEditorIns().then(()=>{});
        });
        this.selectParticiDialogRef.beforeClosed().subscribe((data:any)=>{
          mediumDialogSubscription.unsubscribe()
          smallSubscription.unsubscribe()
          smallDialogSubscription.unsubscribe()
          this.reloadCkEditor().then(()=>{
            setTimeout(function(){
              //$("#momTabHead"+tempThis.pkMoMDetailId).click();
              tempThis.initializeCkeditor();
            },50);
          });
        });
      });
    }
  }

  removeCkEditorIns(){
    // No-op with Angular CKEditor wrapper
    return Promise.resolve(true);
  }
  ngAfterViewChecked(){
    
  }
  ngAfterContentChecked(){
    
  }

  reloadCkEditor(){
    var tempThis=this;
    return new Promise(async(resolve, reject) => {
      
      //  this.removeCkEditorIns().then(()=>{
      this.fetchMoMDetailListByMeeting('').then(()=>{
        // tempThis.initializeCkeditor();
        tempThis.getCurrentMomStatus();
        //this.selected.setValue(0);
        //   this.removeCkEditorIns().then(()=>{
        // setTimeout(function(){
        
        //   tempThis.initializeCkeditor();
        // },500);
        resolve(this.momList);
      });
      //   });
    });
  }
  getCurrentMomStatus(){
    if(this.momList!=null && this.momList.length>0){
      var curMomInfo = this.momList.filter((obj:any) => obj.pkMomDetailId == this.pkMoMDetailId);
      
      if(curMomInfo!=null && curMomInfo.length>0){
        if(curMomInfo[0].momStatusCode!=undefined && curMomInfo[0].momStatusCode!=null){
          this.curMomStatusCode=curMomInfo[0].momStatusCode;
        }
        if(curMomInfo[0].momContent!=null && curMomInfo[0].momContent!=undefined){
          this.nodeValue=curMomInfo[0].momContent;
        }
      }

    }
  }

  openMoMSelectApprovalDialog(){
    var tempThis=this;
    this.checkAllMomApproved();
    if(this.momList==null || this.momList==undefined || this.momList.length<=0){
      this.notifier.show({
        type: 'error',
        message: environment_msg.msg_error_create_mom
      });
    }else if(this.isAllMomApproved){
      this.notifier.show({
        type: 'error',
        message: environment_msg.msg_error_mom_already_approved
      });
    }else if(this.isEmptyMomContent()){
      this.notifier.show({
        type: 'error',
        message: environment_msg.msg_error_mom_content
      });
    }else{
      this.spinner.show();
      this.saveEditorContent().then((req: any) => {
        this.spinner.hide();
        this.selectParticiDialogRef = this.dialog.open(ParticReviewSelectDialogComponent, {
          data: {
            title: "MOM Approval Selection",
            meetingResp: this.meetingResponse, curPkMoMDetailId: this.pkMoMDetailId, momList: this.momList,
            reviewType: "APPROVE"
          },
          panelClass: ['animate__animated', 'animate__slideInLeft'],
          disableClose: true,
          position : {
            left : "0%"
          },
          maxWidth : "100%",
          maxHeight: "100vh",
          width: "50%",
          height : "100vh"
        });
        const mediumDialogSubscription = this.isMedium.subscribe(size => {
          if(size.matches){
            this.selectParticiDialogRef.updateSize('70vw','100vh');
          }
        })
        const smallSubscription = this.isSmall.subscribe(size => {
          if(size.matches){
            this.selectParticiDialogRef.updateSize('100vw', '100vh');
          }
        })
        const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
          if (size.matches) {
            this.selectParticiDialogRef.updateSize('100vw', '100vh');
          }
        });
        this.selectParticiDialogRef.afterOpened().subscribe(()=>{
          this.removeCkEditorIns().then(()=>{});
        });
        this.selectParticiDialogRef.beforeClosed().subscribe((data:any)=>{
          mediumDialogSubscription.unsubscribe()
          smallSubscription.unsubscribe()
          smallDialogSubscription.unsubscribe()
          
          if(data!=null && data.momStatusCode!=null){
            this.meetingResponse.commonMomStatusCode=data.momStatusCode;
          }
          this.reloadCkEditor().then(()=>{
            //this.initializeCkeditor();
            setTimeout(function(){
              //$("#momTabHead"+tempThis.pkMoMDetailId).click();
              tempThis.initializeCkeditor();
            },50)

          });
        })
      })
    }
  }

  previewMinutesDialog(){
    var tempThis=this;
    this.checkAllMomApproved();
    if(this.momList==null || this.momList==undefined || this.momList.length<=0){
      this.notifier.show({
        type: 'error',
        message: environment_msg.msg_error_create_mom
      });
    }
    else if(this.isAllMomApproved){
      this.notifier.show({
        type: 'error',
        message: environment_msg.msg_error_mom_already_approved
      });
    }else if(this.isEmptyMomContent()){
      this.notifier.show({
        type: 'error',
        message: environment_msg.msg_error_mom_content
      });
    } else {
      this.spinner.show();
      this.saveEditorContent().then((req: any) => {
        this.spinner.hide();
   
        this.previewDialogRef = this.dialog.open(PreviewMinutesDialogComponent, {
          data: { meetingInfo: this.meetingResponse, momList: this.momList, curPkMoMDetailId: this.pkMoMDetailId },
          panelClass: ['parent-dialog-container'],
          maxWidth : "100%",
          maxHeight : "100vh",
          minWidth : "80%",
          minHeight : "80vh",
        })
        this.previewDialogRef.afterOpened().subscribe(()=>{
          this.removeCkEditorIns().then(()=>{});
        });
        this.previewDialogRef.beforeClosed().subscribe((data:any)=>{
          this.reloadCkEditor().then(()=>{
            setTimeout(function(){
              //$("#momTabHead"+tempThis.pkMoMDetailId).click();
              tempThis.initializeCkeditor();
            },50);
          });
        });
      })
    }
  }
  fetchSummarizedText() {
    this.spinner.show();
    const teamsMeetingId = localStorage.getItem('teamsMeetingId');
    const userId = 147;
    console.log('teamsMeetingId : ',teamsMeetingId)
    const url = 'MSo4ZmYyZjc3Yi00NDMyLTQ2NzAtOWU1OC04YjZhYmI5NDdhZTAqMCoqMTk6bWVldGluZ19OMll5WlRJd09URXROelZsWmkwME5EZ3dMVGcyTUdJdE1qUTFNV016WkRSaE4yUmlAdGhyZWFkLnYy' + '/transcripts?userId=147'
    var test=this.pkMoMDetailId
    const timeoutHandle = setTimeout(() => {
      this.spinner.hide();
      //console.warn('Spinner fallback: Hiding spinner after timeout');
    }, 120000); 
    return new Promise((resolve, reject) => {
      var reqJSON={
        "meetingId" : this.meetingId,
      "templateType" : localStorage.getItem('templateType'),
      "decryptKey":localStorage.getItem("decryptKey"),
      // "content":content
      }
      
      if(reqJSON!=null){
      this.momService.fetchSummarizedText(reqJSON).subscribe(
        (res: any) => {
          // Log the raw response to debug formatting  
          // Ensure new lines are replaced with <br> tags
          const formattedContent = res.body.replace(/\n/g, "<br>");
          // Update iframe content
          const iframeElem = $("#momCkEditor" + test).parent().find("iframe").contents().find("body");
          iframeElem.html(formattedContent);
          this.nodeValue = formattedContent;
          resolve(this.nodeValue);
          clearTimeout(timeoutHandle); 
          this.spinner.hide();
        },
        (error) => {
          clearTimeout(timeoutHandle); 
          this.spinner.hide();
          this.sideNav.alertNotifyError('Unable to fetch content');
          reject(error);
        }
        
      );
      }
    });
   
  }


// fetchSummarizedText() {

//   this.spinner.show();
 
//   const userId = 147;
//   const meetingId = this.meetingResponse?.meetingId;
  
//   if (!meetingId) {
//     this.spinner.hide();
//     this.sideNav.alertNotifyError('Meeting ID not found');
//     return;
//   }

//   console.log('Fetching meeting details for meetingId:', meetingId);

//   // First, get the meeting object to retrieve onlineMeetingId
//   this.meetingService.getMeetingById(meetingId).subscribe({
//     next: (meetingResp: any) => {
//       console.log('Meeting details response:', meetingResp);
      
//       const meeting = meetingResp?.body?.meeting;
//       const teamsMeetingId = meeting?.onlineMeetingId;

//       if (!teamsMeetingId) {
//         this.spinner.hide();
//         this.sideNav.alertNotifyError('Teams meeting ID not found in meeting details');
//         return;
//       }

//       console.log('teamsMeetingId from meeting object:', teamsMeetingId);

//       const url = teamsMeetingId + '/transcripts?userId=' + userId;

//       this.momService.teamsMeetingDiscussion(url).subscribe({
//         next: (data: any) => {
//           console.log('Teams data : ', data);

//           // ✅ CORRECT PATH
//           const transcripts = data?.body?.transcripts;

//           if (!transcripts || transcripts.length === 0) {
//             this.spinner.hide();
//             this.sideNav.alertNotifyError('No transcript available');
//             return;
//           }

//           const content = transcripts[0].vttContent;

//           if (!content || content.trim().length === 0) {
//             this.spinner.hide();
//             this.sideNav.alertNotifyError('Transcript content is empty');
//             return;
//           }
 
//           const test = this.pkMoMDetailId;
 
//           const timeoutHandle = setTimeout(() => {
//             this.spinner.hide();
//           }, 120000);
 
//           // ✅ SEND RAW STRING ONLY
//           this.momService.fetchSummarizedText(content).subscribe({
//             next: (res: any) => {
//               console.log('Res : ',res)
//               const formattedContent = res.body.summary.replace(/\n/g, '<br>');
 
//               const iframeElem = $('#momCkEditor' + test)
//                 .parent()
//                 .find('iframe')
//                 .contents()
//                 .find('body');
 
//               iframeElem.html(formattedContent);
//               this.nodeValue = formattedContent;
 
//               clearTimeout(timeoutHandle);
//               this.spinner.hide();
//             },
//             error: () => {
//               clearTimeout(timeoutHandle);
//               this.spinner.hide();
//               this.sideNav.alertNotifyError('Unable to fetch summary');
//             }
//           });
//         },
//         error: () => {
//           this.spinner.hide();
//           this.sideNav.alertNotifyError('Unable to fetch Teams transcript');
//         }
//       });
//     },
//     error: (err: any) => {
//       console.error('Error fetching meeting details:', err);
//       this.spinner.hide();
//       this.sideNav.alertNotifyError('Unable to fetch meeting details');
//     }
//   });
// }

  

  handleButtonClick(selectAfterAdding:any) {
    // Find the index dynamically or set a default index
    const defaultIndex = this.momList.length > 0 ? 0 : -1;
    this.addTab(selectAfterAdding, defaultIndex);
  }

  ngOnChange(){
    //window.alert("triggered")
  }

  ngOnDestroy(){
    this.destroyCKEditorInstances();
    // for (var instance in CKEDITOR.instances) {
    //   CKEDITOR.instances[instance].destroy();
    // }
  }
  

  onSettemplate(curMom:any): void {
 
    this.spinner.show();
    this.momService.fetchMoMDetail(this.meetingId).subscribe(res => {
    this.spinner.hide();
 
    this.dialog.open(GrapesJsPopupComponent, {
      data: {
        momRes : {
        pkMomDetailId:this.pkMoMDetailId,
        momTitle:this.curMomTitle,
        momStatusCode:this.curMomStatusCode,
        meetingId : this.meetingId,
        minTemplateId : res.body.minTemplateId,
        categoryId : res.body.categoryId
        },
        curMom:curMom,
        meetingResp : this.meetingResponse,
        option : 'categoryUpdate'
      },
    }).afterClosed().subscribe((response:any) => {
      // this.updateTemplate = false;
    });
})
}
resizeImages(editor: any) {
  const images = editor.document.getElementsByTag('img');
  for (let i = 0; i < images.count(); i++) {
    const img = images.getItem(i);
    if (img) {
      img.setAttribute('width', '650px');
      img.removeAttribute('height'); 
    }
  }
}

}
